import React from "react";
import CircularLoader from "./CircularLoader";

const TableComponent = ({
  columns,
  data,
  isLoading,
  onRowClick,
  onRowMouseEnter,
  onRowMouseLeave,
  hoveredRowIndex,
  renderCell,
  emptyMessage = "No records found.",
}) => {
  return (
    <div className="border-l-2 border-r-2 border-[#E5E5E5] bg-white mt-3 overflow-x-auto">
      <table className="w-full border-t-0">
        <thead className="bg-[#F8F8F8] border-b">
          <tr className="text-left text-xs text-[#535E83] uppercase">
            {columns.map((col, index) => {
              const isLast = index === columns.length - 1;
              return (
                <th
                  key={col.id}
                  className={`px-8 py-3 ${isLast ? "" : "border-r border-gray-200"}`}
                >
                  <div className="flex items-center justify-between text-sm font-euclid font-semibold">
                    {col.label}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan={columns.length} className="py-20">
                <div className="flex flex-col justify-center items-center gap-3">
                  <CircularLoader size={40} color="border-[#007DFE]" />
                  <span className="text-[#535E83] font-semibold text-sm">
                    Loading...
                  </span>
                </div>
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-10 text-[#535E83]"
              >
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className="border-b hover:bg-gray-200"
                onClick={() => onRowClick && onRowClick(row, rowIndex)}
                onMouseEnter={() =>
                  onRowMouseEnter && onRowMouseEnter(row, rowIndex)
                }
                onMouseLeave={() =>
                  onRowMouseLeave && onRowMouseLeave(row, rowIndex)
                }
              >
                {columns.map((col, colIndex) => {
                  const isLast = colIndex === columns.length - 1;
                  return renderCell(col, row, rowIndex, colIndex, isLast, hoveredRowIndex === rowIndex);
                })}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TableComponent;
